import { AnchorHTMLAttributes, useEffect, useState } from 'react'

import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'

import { ArcadeButton, ArcadeButtonLink } from '@cash-design-system/react'
import logger from '@cash-web/shared/util-logger'
import { useArcadeMigrationFeatureFlag } from '@cash-web/shared-data-access-arcade-migration'
import * as fetchUtils from '@cash-web/shared-util-fetch'

import { STATUS_PAGE_API_URL, STATUS_PAGE_URL } from '../../status-page-urls'

const Container = styled.a`
  text-decoration: none;
`

interface Component {
  status: string
}

interface StatusPageResponse {
  components?: Component[]
}

type Props = AnchorHTMLAttributes<HTMLAnchorElement>

function CheckStatusPageButton({ ...props }: Props) {
  const [issueDetected, setIssueDetected] = useState(false)
  const { t } = useTranslation()
  const isArcadeMigrationEnabled = useArcadeMigrationFeatureFlag('apps')

  useEffect(() => {
    fetchUtils.get<StatusPageResponse>(STATUS_PAGE_API_URL).then(response => {
      logger.addBreadcrumb('StatusPageResponse', { response })

      if (!response.components) {
        setIssueDetected(true)
      } else {
        const nonOperationalComponents = response.components.filter(component => component.status !== 'operational')
        if (nonOperationalComponents.length > 0) {
          setIssueDetected(true)
        }
      }
    })
  }, [])

  const buttonCopy = t('Is Cash App Working?', { context: 'Title of the check status page button' })

  if (!issueDetected) {
    return null
  }
  if (isArcadeMigrationEnabled) {
    return (
      <ArcadeButtonLink
        aria-label={buttonCopy}
        href={STATUS_PAGE_URL}
        prominence="standard"
        rel="noreferrer"
        size="cta"
        target="_blank"
      >
        {buttonCopy}
      </ArcadeButtonLink>
    )
  }

  return (
    <Container role="link" target="_blank" rel="noreferrer" href={STATUS_PAGE_URL} {...props}>
      <ArcadeButton size="cta" prominence="standard">
        {buttonCopy}
      </ArcadeButton>
    </Container>
  )
}

export default CheckStatusPageButton
